import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { makeStyles } from "@material-ui/core/styles";
import Tabel from "./AdsTabel";
import { getAds, delAds } from "../../Services/ads";
import { Pagination } from "@material-ui/lab";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useDispatch } from "react-redux";
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import * as icons from "@material-ui/icons";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";

const useStyles = makeStyles((theme) => ({
  Btn: {
    borderRadius: 0,
    color: "#fff",
    backgroundColor: "#6DBCDB",
    "&:hover": {
      backgroundColor: "#0097e6",
    },
  },
}));

const Categories = ({ history }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(1);
  const classes = useStyles();
  const handleAdd = () => {
    const { push } = history;
    push("/adsAdd");
  };
  const initRows = async (page) => {
    dispatch(showLoading());
    let { data } = await getAds(page, search);
    setCount(data.count);
    setRows(data.data);
    dispatch(hideLoading());
  };
  const handleEdit = async (idx) => {
    const { push } = history;
    push({ pathname: "/adsEdit", state: { ...rows[idx] } });
  };
  const handleRemove = async (id, name) => {
    let isSure = await swal({
      title: "Are you sure?",
      text: `Are you sure to delete ${name}!`,
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    });
    if (isSure) {
      try {
        dispatch(showLoading());
        await delAds(id);
        swal("success!", "successfully Ads deleted!", "success");
        if (page == 1) await initRows(1);
        else setPage(1);
      } catch (error) {
        let msg = "some error occured";
        let { status, data } = error.response;
        if (status == 400 || status == 401) {
          msg = data.msg;
        }
        swal("wrong!", msg, "error");
      } finally {
        dispatch(hideLoading());
      }
    }
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleSearchEnter = async () => {
    dispatch(showLoading());
    try {
      initRows(1);
      setPage(1);
    } catch (error) {
      let msg = "some error occured";
      let { status, data } = error.response;
      if (status == 400 || status == 401) {
        msg = data.msg;
      }
      swal("wrong!", msg, "error");
    } finally {
      dispatch(hideLoading());
    }
  };

  const handlePage = async (e, value) => {
    setPage(value);
  };
  useEffect(async () => {
    try {
      dispatch(showLoading());
      await initRows(page);
    } catch (error) {
      let msg = "some error occured";
      let { status, data } = error.response;
      if (status == 400 || status == 401) {
        msg = data.msg;
      }
      swal("wrong!", msg, "error");
    } finally {
      dispatch(hideLoading());
    }
  }, [page]);

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col md="3" className="mt-2">
            <Button
              onClick={handleAdd}
              fullWidth
              variant="contained"
              className={classes.Btn}
            >
              + Add Ads
            </Button>
          </Col>
          <Col md="4" className="mt-2">
            <TextField
              fullWidth
              size="small"
              id="search"
              label="Search by Name"
              variant="outlined"
              value={search}
              onChange={handleSearch}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearchEnter();
              }}
              className={classes.textField}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={handleSearchEnter}>
                      <icons.Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-2">
            <Tabel
              rows={rows}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
            />
          </Col>
        </Row>
        {count > 6 ? (
          <div className="mt-3">
            <Pagination
              count={parseInt((count + 5) / 6)}
              onChange={handlePage}
              page={page}
              style={{ display: "flex", justifyContent: "center" }}
              variant="outlined"
              color="secondary"
            />
          </div>
        ) : null}
      </Container>
    </>
  );
};

export default withRouter(Categories);
